import {
  format, addDays, startOfWeek, addWeeks,
} from 'date-fns';

// Get Monday of the week
export const getWeekStart = (date) => startOfWeek(date, { weekStartsOn: 1 });
export const addWeeksToDate = (date, weeks) => addWeeks(date, weeks);

export const addDaysToDate = (date, days) => addDays(date, days);

export const formatDateKey = (date) => format(date, 'yyyy-MM-dd');

export const formatDayName = (date) => format(date, 'EEE');

export const formatShortDate = (date) => format(date, 'MMM d');

export const formatDateRange = (startDate, endDate) => (
  `${format(startDate, 'MMM d')} - ${format(endDate, 'MMM d, yyyy')}`
);

// Generate Mon-Sun dates over the given number of weeks (default 2 weeks = 14 days)
export const generateDates = (startDate, weeks = 2) => {
  const dates = [];
  let current = new Date(startDate);

  for (let week = 0; week < weeks; week += 1) {
    for (let day = 0; day < 7; day += 1) { // Mon-Sun (7 days)
      dates.push(new Date(current));
      current = addDays(current, 1);
    }
  }

  return dates;
};

// Group jobs by date key
export const groupJobsByDate = (jobs) => jobs.reduce((acc, job) => {
  const dateKey = job.date.split('T')[0];
  if (!acc[dateKey]) acc[dateKey] = [];
  acc[dateKey].push(job);
  return acc;
}, {});
